module.exports = __webpack_public_path__ + "img/DTMClassic.20f63cc4.svg";